module.exports = __webpack_public_path__ + "static/media/like.9f2cbd79.svg";